<template>
  <div>
    <div class="md-layout grid-linha grid-header">
      <div class="md-layout-item" :style="{minWidth: c.Width, maxWidth: c.Width}" v-for="c in Header" :key="c.Field"><span class="s-h3">{{c.Titulo}}</span></div>
    </div>

    <div class="md-layout grid-linha-item" v-for="item in Data" :key="Data.indexOf(item)">
      <div class="md-layout-item grid-linha-data" :style="{minWidth: c.Width, maxWidth: c.Width}" v-for="c in Header" :key="c.Field">
        <span v-if="c.Action">{{c.Action(item[c.Field])}}</span>
        <span v-else-if="c.Tipo == 'datetime'" v-formatdatetime="item[c.Field]"></span>
        <span v-else-if="c.Tipo == 'date'" v-formatdate="item[c.Field]"></span>
        <span v-else-if="c.Tipo == 'moeda'" v-formatmoeda="item[c.Field]"></span>
        <span v-else>{{item[c.Field]}}</span>
      </div>
    </div>
  </div>

</template>

<script>
  import { formatdatetime } from '@/directives/formatdatetime.js';
  import { formatdate } from '@/directives/formatdate.js';
  import { formatmoeda } from '@/directives/formatmoeda.js';

  export default {
    name: 'GridLinha',
    directives: {
      formatdatetime,
      formatdate,
      formatmoeda
    },
    props: {
      Data: {
        type: Array
      },
      Header: {
        type: Array
      }
    },
    data() {
      return {
        aluno: null,
        dados: this.Data,
        headers: this.Header,
      }
    },
    created() {
      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {
        let a = JSON.parse(sessionStorage.Aluno);
        //Coloca o perfil de aluno disponível na variável aluno
        if (a.PerfilAluno) {
          this.aluno = a.PerfilAluno;
        }
        else
          this.$router.push('home');
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .grid-linha,
  .grid-linha-item {
    text-align: center;
  }

  .grid-linha-item {
    background-color: white;
    margin: 1em 0 1em 0;
    border-radius: 4px;
    border-left: 4px solid #B2B2B2;
    padding: 10px 0 10px 0;
  }

  .grid-linha-data {
    overflow: hidden;
    text-overflow: ellipsis
  }
</style>
